export default "__VITE_ASSET__BruYR_no__"